import { Component, Input, OnInit } from '@angular/core';

import { Storage } from '@ionic/storage-angular';
import { ModalController, NavController, PopoverController } from '@ionic/angular';

import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';

@Component({
  selector: 'app-general-popover',
  templateUrl: './general-popover.component.html',
  styleUrls: ['./general-popover.component.scss'],
})
export class GeneralPopoverComponent implements OnInit {
  @Input() selectedMenu: string;

  idAdmin: any;
  storageUsuario: any;

  menu = {
    dashboard: false,
    plantillas: false,
    informes: false,
    configuracion: false
  };

  submenus = {
    licencias: false,
  };

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private storage: Storage) { }

  ngOnInit() {
    this.storage.get('usuario').then((usuario) => {
      this.storageUsuario = usuario;
    })
      .then(() => {
        this.idAdmin = this.storageUsuario.idAdmin;
      });

    if (this.selectedMenu) {
      this.activateMenu(this.selectedMenu);
    }
  }

  activateMenu(menuName: string) {
    this.menu = {
      dashboard: false,
      plantillas: false,
      informes: false,
      configuracion: false
    };

    if (menuName in this.menu) {
      this.menu[menuName] = true;
    }
  }

  toggleSubMenu(submenuName: string) {
    this.submenus[submenuName] = !this.submenus[submenuName];
  }

  ir(ruta: string) {
    this.navCtrl.navigateForward('/folder/' + ruta).then(() => {
      if (ruta === 'inicio') {
        window.location.reload();
      }
      this.closePopover();
    });
  }

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });
    this.closePopover();
    return await modal.present();
  }

  async closePopover() {
    await this.popoverController.dismiss();
  }

}
